"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CatalogConverter = void 0;

var _Instructions = require("./Instructions");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class CatalogConverter {
  static createIdsContext(target) {
    CatalogConverter.recursiveCall(target, item => {
      //Obrigatoriamente o tipo deve ser diferente de size pois size é um componente virtual
      if (item.type != "size" && `${item._id}`.indexOf('_') == 0) {
        const objectKeyLength = Object.keys(CatalogConverter.contextId).length || 1;
        CatalogConverter.contextId[item._id] = BigInt(objectKeyLength);
      }
    });
  }

  static recursiveCallWithParent({
    source,
    parent
  }, fn) {
    fn(source, parent);
    ["items", "edges", "doughs", "extra_ingredients"].forEach(key => {
      source[key] && source[key].length > 0 && source[key].forEach(i => CatalogConverter.recursiveCall({
        source: i,
        parent: source
      }, fn));
    });
  }

  static recursiveCall(source, fn) {
    fn(source);
    ["items", "edges", "doughs", "extra_ingredients"].forEach(key => {
      source[key] && source[key].length > 0 && source[key].forEach(i => CatalogConverter.recursiveCall(i, fn));
    });
  }

  static getObjectsByParams(source, param, value) {
    const findedItems = [];
    CatalogConverter.recursiveCall(source, item => {
      if (item[param] == value) {
        findedItems.push(item);
      }
    });
    return findedItems;
  }

  static convertCatalogToScript(source, target) {
    const instructions = [];
    CatalogConverter.createIdsContext(target); //Verificar os itens deletados

    CatalogConverter.recursiveCall(source, item => {
      const findedObjects = CatalogConverter.getObjectsByParams(target, "_id", item._id);

      if (findedObjects.length == 0) {
        instructions.push([BigInt(item._id) << _Instructions.INSTRUCTIONS_LENGTH | _Instructions.INSTRUCTIONS.DELETE]);
        return;
      } // const itemKeys = Object.keys(item).filter((key) => ["_id", "items", "sizes", "edges", "doughs", "extra_ingredients"].indexOf(key) == -1);
      // const targetItem = findedObjects[0];
      // const objectToUpdate = {};
      // itemKeys.forEach((key) => {
      //     //Checar no target se a propriedades no source é diferente
      //     if (item[key] != targetItem[key]) {
      //         objectToUpdate[key] = targetItem[key];
      //     }
      // });
      // if (Object.keys(objectToUpdate).length > 0) {
      //     if() {
      //         instructions.push([BigInt(item._id) << INSTRUCTIONS_LENGTH | INSTRUCTIONS.UPDATE | INSTRUCTIONS.TEMPORARY, objectToUpdate]);
      //     } else {
      //         instructions.push([BigInt(item._id) << INSTRUCTIONS_LENGTH | INSTRUCTIONS.UPDATE, objectToUpdate]);
      //     }
      // }

    }); // Verificar os itens adicionados

    CatalogConverter.recursiveCall(target, item => {
      const findedObjects = CatalogConverter.getObjectsByParams(source, "_id", item._id);

      if (findedObjects.length == 0) {
        if (CatalogConverter.contextId[item._id]) {
          item._id = CatalogConverter.contextId[item._id];
        }

        let isTemporaryParent = false;

        if (CatalogConverter.contextId[item.parent]) {
          isTemporaryParent = true;
          item.parent = CatalogConverter.contextId[item.parent];
        }

        instructions.push([BigInt(item.parent || 0) << _Instructions.INSTRUCTIONS_LENGTH | _Instructions.INSTRUCTIONS.CREATE | (isTemporaryParent && _Instructions.INSTRUCTIONS.TEMPORARY || 0n), item]);
      }
    });
    return instructions;
  }

}

exports.CatalogConverter = CatalogConverter;

_defineProperty(CatalogConverter, "contextId", {});